import React, { useState, useEffect } from "react";
import { Color } from "config/colors";
import { CustomLink } from "components/Typography/text.styled";
import { Badge, MenuItemLabel, NavIconLi } from "./navBarMenuList.styled";
import { CustomIcon } from "components/icon/customIcon.component";
import { useTranslation } from "react-i18next";
import { useTimeReportStore } from "web-apps/company/stores/timeReportStore/timeReportStore";
import { useApplicationStore } from "web-apps/company/stores/applicationStore/applicationStore";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import type { MenuItem } from "../menu-utils";

type Props = {
  readonly menuList: MenuItem[];
  readonly setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MenuItems: React.FC<Props> = ({ menuList, setOpen }) => {
  const { t } = useTranslation();
  const [timeReportState] = useTimeReportStore();
  const [applicationState] = useApplicationStore();
  const [unhandledTimereportsLength, setUnhandledTimereportsLength] =
    useState(0);

  useEffect(() => {
    setUnhandledTimereportsLength(timeReportState.unhandledTimeReportCount);
  }, [timeReportState.unhandledTimeReportCount, applicationState.applications]);

  return (
    <>
      {menuList.map((item) => {
        const isDisabled = item.disabledReason != null;
        const menuItem = (
          <CustomLink
            color={Color.SeaBlue500}
            to={item.path}
            aria-disabled={isDisabled}
            onClick={() => setOpen(false)}
          >
            <CustomIcon
              name={item.image}
              color={Color.SeaBlue500}
              padding="5px"
            />
            {item.text === t("CompanyTimeReport.TimeReports") &&
              unhandledTimereportsLength > 0 && (
                <Badge>{unhandledTimereportsLength}</Badge>
              )}
            {item.text === t("ApplicationsCompany.Applications") &&
              applicationState.applicationsCount > 0 && (
                <Badge>{applicationState.applicationsCount}</Badge>
              )}
            <MenuItemLabel>{item.text}</MenuItemLabel>
          </CustomLink>
        );

        return (
          <NavIconLi
            active={window.location.pathname === item.path}
            key={item.path}
            $disabled={isDisabled}
            onClickCapture={(event) => {
              if (!isDisabled) return;
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            {isDisabled ? (
              <TooltipHover text={item.disabledReason} arrow="up" fullWidth>
                {menuItem}
              </TooltipHover>
            ) : (
              menuItem
            )}
          </NavIconLi>
        );
      })}
    </>
  );
};
